<nwm-menu />
<div class="content">
  <div class="main">
    <div class="row my-4">
      <div class="col-xxl-10 offset-xxl-1">

        <div class="row my-4">
          <div class="col-sm-6 activities-header">
            <h1 class="mr-3">All Activities</h1>
            <span>All values are shown in CAD.</span>
          </div>
          <div class="col-sm-6 text-right">
            <button class="btn-primary sml-btn my-1 d-print-none" (click)="openModalToContactAdvisor(pgfModal, 'PgfDonation')">Donate to Fund</button>
            <button class="btn-primary sml-btn ml-3 my-1 d-print-none" (click)="openModalToContactAdvisor(pgfModal, 'PgfGrant')">Grant to Charity</button>
            <button class="btn-primary sml-btn ml-3 my-1 d-print-none" (click)="openModalToContactAdvisor(pgfModal, 'MessageAdvisor')">Contact Us</button>
          </div>
        </div>
        <hr>
          <div class="row my-4">
            <div class="col-lg-7 inline">
              <div>
                <b>Donations Since Inception</b><br>
                {{inceptionDonations | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}
              </div>
              <div>
                <b>Grants Since Inception</b><br>
                {{inceptionGrants | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}
              </div>
              <div>
                <b>Donations YTD</b><br>
                {{ytdDonations | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}
              </div>
              <div>
                <b>Grants YTD</b><br>
                {{ytdGrants | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}
              </div>
            </div>
            <div class="col-lg-5 text-right">
              <select [(ngModel)]="dateRange" (ngModelChange)="filterData()" class="form-control w-auto my-1 ml-3 d-inline-block">
                @for (opt of dateRangeOptions; track opt) {
                  <option [ngValue]="opt.monthsRange">{{opt.text}}</option>
                }
              </select>
              <div ngbDropdown class="d-inline-block custom-dropdown my-1 ml-3">
                <button type="button" class="btn" id="dropdownBasic1" ngbDropdownToggle>
                  Filter
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="pb-0" (change)="filterData()">
                  <div class="custom-dropdown-item">
                    <input type="checkbox" name="DonationToFunds" id="DonationToFunds" [(ngModel)]="showDonations">
                    <label for="DonationToFunds">Donation to Funds</label>
                  </div>
                  <div class="custom-dropdown-item">
                    <input type="checkbox" name="GrantsToCharities" id="GrantsToCharities" [(ngModel)]="showGrants">
                    <label for="GrantsToCharities">Grants to Charities</label>
                  </div>
                </div>
              </div>
              <a (click)="export()" tabindex="0" class="export-btn d-print-none my-1">Export</a>
            </div>
          </div>
          @if (dataLoaded) {
            <div class="row">
              <div class="col-12">
                <div class="scrollable-wrap">
                  <div class="scrollable">
                    <div class="scrollable-button left"></div>
                    <div class="scrollable-button"></div>
                    <table width="100%" class="NWMtable sticky_header table table-striped mb-0">
                      <thead>
                        <tr>
                          <td width="140" role="button" (click)="toggleSort('ActivityDate')" class="sortable">
                            <span>Date</span>
                            <i class="fa" [ngClass]="sortField === 'ActivityDate' ? (sortDir<0 ? 'fa-sort-asc ml-2' : 'fa-sort-desc ml-2') : ''" aria-hidden="true"></i>
                          </td>
                          <td width="50" role="button" (click)="toggleSort('ActivityStatus')" class="sortable">
                            <span>Status</span>
                            <i class="fa" [ngClass]="sortField === 'ActivityStatus' ? (sortDir<0 ? 'fa-sort-asc ml-2' : 'fa-sort-desc ml-2') : ''" aria-hidden="true"></i>
                          </td>
                          <td role="button" (click)="toggleSort('CharityName')" class="sortable">
                            <span>Charity</span>
                            <i class="fa" [ngClass]="sortField === 'CharityName' ? (sortDir<0 ? 'fa-sort-asc ml-2' : 'fa-sort-desc ml-2') : ''" aria-hidden="true"></i>
                          </td>
                          <td width="160" role="button" class="text-right sortable" (click)="toggleSort('DonationAmountCAD')">
                            <span>Donate to Fund</span>
                            <i class="fa" [ngClass]="sortField === 'DonationAmountCAD' ? (sortDir<0 ? 'fa-sort-asc ml-2' : 'fa-sort-desc ml-2') : ''" aria-hidden="true"></i>
                          </td>
                          <td width="160" role="button" class="text-right sortable" (click)="toggleSort('GrantAmountCAD')">
                            <span>Grant to Charity</span>
                            <i class="fa" [ngClass]="sortField === 'GrantAmountCAD' ? (sortDir<0 ? 'fa-sort-asc ml-2' : 'fa-sort-desc ml-2') : ''" aria-hidden="true"></i>
                          </td>
                          <td width="40"></td>
                        </tr>
                      </thead>
                      <tbody>
                        @if (pagedData) {
                          <ng-container *ngTemplateOutlet="dataList" />
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="form-inline float-right mb-4">
                  <div class="form-group pt-4">
                    <label for="pageSize" class="font-weight-bold">Rows Displayed</label>
                    <select [(ngModel)]="pageSize" name="pageSize" class="form-control mx-sm-3" id="pageSize" (ngModelChange)="filterData()">
                      <option  [value]="0" [selected]="!pageSize">All</option>
                      @for (o of pageOptions; track o) {
                        <option [value]="o" [selected]="pageSize  === o">{{o}}</option>
                      }
                    </select>
                  </div>
                  @if (totalPages > 1) {
                    <ngb-pagination [collectionSize]="filteredData.length"
                      [(page)]="page" [maxSize]="2" (pageChange)="setPage()"
                      class="pagination pt-4"
                      [pageSize]="pageSize"
                      [boundaryLinks]="true">
                      <ng-template ngbPaginationFirst>First</ng-template>
                      <ng-template ngbPaginationPrevious>Previous</ng-template>
                      <ng-template ngbPaginationNext>Next</ng-template>
                      <ng-template ngbPaginationLast>Last</ng-template>
                    </ngb-pagination>
                  }
                </div>
              </div>
            </div>
          }

        </div>
      </div>
    </div>
  </div>

  <ng-template #dataList>
    @if (pagedData) {
      @for (row of pagedData; track row) {
        <tr>
          <td class="text-left align-middle">
            {{row.ActivityDate | date:'MMM d, yyyy'}}
          </td>
          <td class="text-center align-middle activity-status status-{{row.ActivityStatus === 'Complete' ? 'Complete': 'Pending'}}" ngbTooltip="{{row.ActivityStatus}}" container="body">
            @if (row.ActivityStatus !== 'Complete') {
              <span class="material-icons" aria-label="Pending">
                more_horiz
              </span>
            }
            @if (row.ActivityStatus === 'Complete') {
              <span class="material-icons" aria-label="Complete">
                done
              </span>
            }
          </td>
          @if (row.ActivityType === 'Donation') {
            <td class="text-left align-middle">
              Donation from {{row.DonorName}}
            </td>
          }
          @if (row.ActivityType === 'Grant') {
            <td class="text-left align-middle">
              {{row.CharityName}}
            </td>
          }
          @if (row.ActivityType === 'Donation') {
            <td class="text-right align-middle td-amount">
              {{row.DonationAmountCAD | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}
              <ng-container *ngTemplateOutlet="usdIcon;context:row" />
            </td>
          }
          <td></td>
          @if (row.ActivityType === 'Grant') {
            <td class="text-right align-middle td-amount">
              {{row.GrantAmountCAD | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}
              <ng-container *ngTemplateOutlet="usdIcon;context:row" />
            </td>
          }
          <td>
            @if (row.Note !== '') {
              <span class="material-icons" [ngbTooltip]="row.Note" container="body" tooltipClass="white-space-pre-line">description</span>
            }
          </td>
        </tr>
      }
    }
  </ng-template>

  <ng-template #pgfModal let-modal>
    <nwm-advisor-contact [formAction]="modalAction" [formTitle]="modalTitle" (formCancelled)="modal.close()" />
  </ng-template>

  <ng-template #usdIcon let-currency="TransactionCurrency" let-amount="AmountUSD">
    @if (currency === 'USD') {
      <i class="usdIcon" ngbTooltip="USD {{amount | number:'1.0-0' | minusSignToParens}}" container="body">fx</i>
    }
  </ng-template>